import { Button } from "@/components/ui/button";
import { Phone, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
const heroImage = "/hero-garage-door.webp";

const Hero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
      {/* Optimized LCP image with explicit dimensions and priority loading */}
      <div className="absolute inset-0 z-0">
        <img 
          src={heroImage}
          alt="Professional garage door repair service"
          className="w-full h-full object-cover"
          width={1920}
          height={1080}
          fetchPriority="high"
          decoding="async"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/90 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-background/60 via-transparent to-background/30" />
      </div>
      
      <div className="container mx-auto px-4 py-28 relative z-10">
        <div className="max-w-2xl animate-fade-in">
          <div className="inline-flex items-center gap-2 bg-accent text-accent-foreground px-5 py-2 rounded-full text-sm font-bold mb-8 shadow-md">
            Professional Garage Door Specialists
          </div>
          
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-foreground mb-6 leading-[1.1] tracking-tight">
            Expert Garage Door
            <span className="block text-accent mt-1">Repairs & Servicing</span>
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground mb-3 leading-relaxed max-w-xl">
            Professional repairs, servicing, and automation across Berkshire, Hampshire & Surrey.
          </p>
          
          <p className="text-base md:text-lg text-muted-foreground mb-10 max-w-xl">
            From routine maintenance to smart upgrades. 
            <span className="text-foreground font-semibold"> Plus 24/7 emergency callouts when you need us most.</span>
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Button size="lg" className="gap-3 text-lg px-8 py-7 bg-accent hover:bg-accent/90 text-accent-foreground shadow-lg hover:shadow-xl transition-all duration-300" asChild>
              <a href="tel:07836393815">
                <Phone className="w-5 h-5" />
                Call Now: 07836 393815
              </a>
            </Button>
            <Button size="lg" variant="outline" className="gap-2 text-lg px-8 py-7 border-2 border-foreground/20 hover:border-accent hover:text-accent transition-all duration-300" asChild>
              <Link to="/contact">
                Get a Free Quote
                <ArrowRight className="w-5 h-5" />
              </Link>
            </Button>
          </div>
          
          <div className="mt-8 flex items-center gap-6 text-sm text-muted-foreground">
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
              Mon–Fri 8am–4:30pm
            </span>
            <span>24/7 emergency service</span>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background to-transparent z-[5]" />
    </section>
  );
};

export default Hero;
